import React from "react";

import ArrowImg from "images/pu/product_tabs/parts/electronic_components_sourcing/arrow.png";
//import AvnetImg from "images/pu/product_tabs/parts/electronic_components_sourcing/avnet.png";
import DigikeyImg from "images/pu/product_tabs/parts/electronic_components_sourcing/digikey.png";
//import FurureImg from "images/pu/product_tabs/parts/electronic_components_sourcing/furure_electronics.png";
import MouserImg from "images/pu/product_tabs/parts/electronic_components_sourcing/mouser.png";
//import NewarkImg from "images/pu/product_tabs/parts/electronic_components_sourcing/newark.png";

const PartsSourcing = () => {

  return (
    <div className="parts-sourcing mt-3">
      <div className="row">
        <div className="col-lg-12">
          <div className="">
            <p className="fw-bold">
              Our network of authorized distributors includes:
            </p>
          </div>
        </div>
      </div>
      <div className="part-suppliers">
        <div className="row">
          <div className="col-xs-4 col-md-2 pe-0">
            <img src={DigikeyImg} className="img-fluid mx-auto align-self-start" alt="Digikey"/>
          </div>
          <div className="col-xs-4 col-md-2 px-0">
            <img src={MouserImg} className="img-fluid mx-auto align-self-start" alt="Mouser"/>
          </div>
          <div className="col-xs-4 col-md-2 ps-0">
            <img src={ArrowImg} className="img-fluid mx-auto align-self-start" alt="Arrow"/>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PartsSourcing;